import * as React from "react";

import { useGetSvgIconFill } from "@intelligems/ig-theme";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const IgWhiteGemIcon = (props: SvgIconProps) => {
  const fill = useGetSvgIconFill(props.color);

  return (
    <SvgIcon sx={{ fill: "none" }} {...props}>
      <svg
        {...props}
        viewBox="0 0 694 589"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M144.678 297.793C157.103 307.672 177.683 315.881 194.379 315.881C211.076 315.881 498.801 315.881 498.801 315.881C518.949 315.881 532.552 310.81 548.502 297.793L616.971 244.831L617.591 244.173L665.338 203.386C676.5 194.176 682.701 181.018 684.561 167.203C684.561 167.203 685.181 161.456 685.181 159.483C685.181 144.352 677.74 131.021 665.338 120.495C656.037 114.574 564.034 27.7586 536.077 14.5862C536.077 14.5862 523.651 8 498.801 8C465.547 8 194.379 8 194.379 8C191.273 7.99994 167.45 8 157.103 14.5862C141.572 24.473 29.7447 119.837 27.2643 120.495C14.8625 131.021 8.0415 146.152 8.0415 161.282C8.0415 161.94 8.0415 165.888 8.0415 167.203C9.28169 181.018 15.4826 194.176 27.2643 203.386C27.2643 203.386 132.253 287.914 144.678 297.793Z"
          stroke={fill}
          strokeWidth="16"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M8.0416 167.203V436.103C8.04078 455.862 21.0466 464.181 26.6363 469.034C44.6453 484.671 135.359 561.241 144.678 567.827C166.423 581 186.939 581 194.38 581L498.801 581C523.652 581 536.077 577.707 548.502 567.827L666.543 469.034C677.702 457.204 685.181 444.19 685.181 427.059V159.482"
          stroke={fill}
          strokeWidth="16"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M617.589 244.173L536.075 146.31C529.863 139.724 505.012 139.724 498.799 139.724H194.378C181.953 139.724 163.315 139.724 157.102 146.31L74.3896 242.858"
          stroke={fill}
          strokeWidth="16"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M548.497 297.793C548.497 297.793 522.34 271.448 514.102 264.862C505.863 258.275 484.985 258.275 481.148 258.275H212.022C205.443 258.275 190.052 258.275 179.067 264.862C168.083 271.448 144.673 297.793 144.673 297.793"
          stroke={fill}
          strokeWidth="16"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M8 297.793C8 314.259 14.2362 326.785 26.638 337.311C37.1796 346.521 126.041 422.931 144.679 436.104C144.679 436.104 163.317 449.276 194.38 449.276L498.801 449.428C518.33 449.428 532.163 447.66 548.503 436.104L666.544 337.311C678.325 327.443 683.942 315.223 685.182 300.75"
          stroke={fill}
          strokeWidth="16"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};
